import { ThunkAction } from '@bridebook/web/app-basic/lib/types';
import { IArticle } from '@bridebook/toolbox/src/types';
import { getArticlePropertiesGeneric } from '@bridebook/web/app-shared/lib/articles/utils';
import { TrackingCategory } from '../tracking-category';
import { TrackingEvent } from '../tracking-event';

interface IExternalLinkWithinArticleData {
  ctaText: string;
  externalUrl: string;
  article?: IArticle | null;
}

export const clickedExternalLinkWithinArticle: (
  payload: IExternalLinkWithinArticleData,
) => ThunkAction<void> =
  (payload) =>
  (_, __, { analyticsService }) =>
    analyticsService.getMethods(TrackingCategory.LoggedOut).track({
      event: TrackingEvent.ClickedExternalLinkWithinArticle,
      ctaText: payload.ctaText,
      externalUrl: payload.externalUrl,
      ...(!!payload.article && getArticlePropertiesGeneric({ article: payload.article })),
    });
